import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { CONFIG, UTILS } from '../const/const';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'src/app/shared/components/toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class SsoInterceptor implements HttpInterceptor, OnDestroy {
  showError: boolean = false;
  errorMessage!: string;
  isLoader: boolean = true;
  emailInvalid!: boolean;
  user: any;

  isSignIn$: Observable<boolean>;

  private isSignInSubject: Subject<boolean>;

  constructor(
    private _activateRoute: ActivatedRoute,
    private _authService: AuthService,
    private _router: Router,
    private _cookies: CookieService,
    public toastService: ToastService
  ) {
    this.isSignInSubject = new Subject<boolean>();
    this.isSignIn$ = this.isSignInSubject.asObservable();
    this._activateRoute.queryParams.subscribe((params) => {
      if (params['token']) {
        let token = params['token'];
        this._authService.logout();
        setTimeout(() => {
          this._authService.signInWithToken(token).subscribe({
            next: (response: any) => {
              if (response.code == 202) {
                response = response.data;
                if (response.stayLogged) {
                  this._cookies.set(
                    'Expires',
                    CONFIG.expiredDate(CONFIG.expiredMinuteTime) + ''
                  );
                }

                if (response.otherLoginURL) {
                  this.showError = true;
                  this.errorMessage = response.message;
                } else {
                  this.isSignInSubject.next(true);
                  // Cyrille ici le message
                  if (this.isLoader) {
                    this.showSuccess(
                      'Vous êtes maintenant connecté en tant que ' +
                        response.username
                    );
                  }

                  localStorage.setItem('user', JSON.stringify(response));
                  localStorage.setItem('x-wsse', response.user_token);
                  this._cookies.set('x-wsse', response.user_token, { path: '/' });
                  try {
                    this._cookies.set('user', JSON.stringify(response), { path: '/' });
                  } catch (e) {}
                  this.showError = false;

                  let regpdValidExpired = false;
                  this._cookies.set(
                    'user_rgpdvalide',
                    JSON.stringify(response.rgpdvalide),
                    { path: '/' }
                  );
                  if (response.rgpdvalide != null) {
                    let dateRgpd = new Date(response.rgpdvalide);
                    let dnow = new Date();
                    if (UTILS.diffdays(dateRgpd, dnow) > 366) {
                      regpdValidExpired = true;
                    }
                  }
                  if (
                    this._router.url &&
                    (this._router.url.includes('connexion') ||
                      this._router.url.includes('mot-de-passe-oublie'))
                  ) {
                    setTimeout(() => {
                      void this._router.navigateByUrl(
                        '/espace-personnel/' +
                          UTILS.replaceSpace(response.username) +
                          '/tableau-de-bord'
                      );
                    }, 50);
                  }
                }
              } else {
                if (this.isLoader) {
                  this.showDanger(response.message);
                }
                this.showError = true;
                // set errorMessage
                this.errorMessage = response.message;
              }
              this.isLoader = false;
            },
            error: (err) => {
              if (this.isLoader) {
                this.showDanger(err);
              }
              this.showError = true;
              // set errorMessage
              this.errorMessage = err;
              this.isLoader = false;
            },
          });
        }, 50);
      }
      if (params['_job']=='searchinchange'){
        // if (this.isLoader) {
          this.showSuccess(
            'Un email a été envoyé à votre Conseiller'
          );
        // }
      }
      if (params['_unsubscribe_new_biens']=='1'){
        // if (this.isLoader) {
          this.showSuccess(
            'Vous êtes bien désinscrit des emails'
          );
        // }
      }
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request);
  }

  showSuccess(message: any) {
    this.toastService.show(message, {
      classname: 'bg-success text-light',
      delay: 5000,
    });
  }

  showDanger(dangerTpl: any) {
    this.toastService.show(dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 5000,
    });
  }

  ngOnDestroy(): void {
    this.toastService.clear();
  }
}
